var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    viewBox: "0 0 18 18",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-279)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.05011304,3.2239387)",
    id: "g916"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#919a9e",
      strokeWidth: 0.8497591,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 8.10000038,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect834-6",
    width: 10.92876,
    height: 13.673617,
    x: 93.054001,
    y: 256.27228,
    ry: 1.6827065,
    transform: "matrix(0.93655189,0.35052897,-0.31472625,0.94918248,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "currentColor",
      strokeWidth: 0.84945285,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 8.10000038,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "m 3.534981,279.29377 h 6.1439883 c 0,0 3.1140187,2.82615 3.1140187,2.84883 v 9.21831 c 0,0.93815 -0.710871,1.69341 -1.593883,1.69341 H 3.534981 c -0.883011,0 -1.5938826,-0.75526 -1.5938826,-1.69341 v -10.37374 c 0,-0.93814 0.7108716,-1.6934 1.5938826,-1.6934 z",
    id: "rect834"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.80862516,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 8.10000038,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "path869",
    d: "m 6.8621202,289.3461 a 3.1690974,3.4457359 0 0 1 -2.9278643,-2.12711 3.1690974,3.4457359 0 0 1 0.6869739,-3.75513 3.1690974,3.4457359 0 0 1 3.4536514,-0.74694 3.1690974,3.4457359 0 0 1 1.9563368,3.18344 H 6.8621202 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#919a9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.85475284,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 8.10000038,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "path869-7",
    d: "m 10.989063,286.49255 a 3.5353491,3.4512141 0 0 1 -3.535349,3.45122 l -10e-8,-3.45122 z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReports);
export default __webpack_public_path__ + "static/media/icon-reports.a01262d932e5da7f721f757073384eba.svg";
export { ForwardRef as ReactComponent };